// @flow

import { type IncomingPayment } from './types';

export function getTransactionStatusDescriptionCode(incomingPayment: IncomingPayment): ?string {
  if (incomingPayment.status !== 'OP') {
    return null;
  }

  return incomingPayment?.transaction_status?.description_code ?? null;
}
